// extracted by mini-css-extract-plugin
export default {"formInputBox":"index_formInputBox_8u1em","formSelect":"index_formSelect_MIoOJ","active":"index_active_eRDaa"};